import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../auth.service';
import { HeaderService } from '../../shared/header/header.service';
import { BreadcrumbService } from '../../shared/breadcrumb/breadcrumb.service';
import { NotificationMessageService } from '../../shared/notification-message/notification-message.service';
import { Router } from "@angular/router";

@Component({
	selector: 'app-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, OnDestroy {

	guest: any = {};
	invalidEmailDomain = true;
	phoneNumberHasDashes = false;
	isSsoUser = false; // Flag to indicate if user is registering via SSO
	ssoData: any = null; // Store SSO data for pre-population

	constructor(
		private authService: AuthService,
		private header: HeaderService,
		private breadcrumb: BreadcrumbService,
		private router: Router,
		private notificationMessage: NotificationMessageService
	) {
		this.header.hide();
		this.breadcrumb.hide();
	}

	ngOnInit() {
		// Check if we have SSO data passed from the login component
		this.loadSsoData();
	}

	/**
	 * Load SSO data from the auth service if available
	 * This data is set when a user attempts SSO login but doesn't have an account
	 */
	loadSsoData() {
		const ssoData = this.authService.getSsoRegistrationData();
		if (ssoData) {
			this.isSsoUser = true;
			this.ssoData = ssoData;

			// Pre-populate the form with SSO data
			this.guest.firstname = ssoData.firstname || '';
			this.guest.lastname = ssoData.lastname || '';
			this.guest.email = ssoData.email || '';

			// Email is valid since it comes from Active Directory
			this.invalidEmailDomain = false;
		}
	}

	checkDomain(emailNewValue) {
		if(typeof(emailNewValue) == 'string' && emailNewValue.toLowerCase().match(/@(gmail|aol|yahoo|hotmail).com/))
			this.invalidEmailDomain = true;
		else
			this.invalidEmailDomain = false;
	}

	register() {
		// Add SSO flag if this is an SSO registration
		if (this.isSsoUser) {
			this.guest.isSsoUser = true;
		}

		this.authService.registerUser(this.guest).subscribe(
			(data: any) => {
				if(data.httpStatus == 'error')
					this.notificationMessage.setMessage(data.msg);
				else if(data.httpStatus == 'success') {
					this.notificationMessage.setMessage(data.msg, 'success');
					this.router.navigate(['/login']);
				}
			}
		);
	}

	onPhoneNumberChanged(value) {
		this.phoneNumberHasDashes = `${value}`.includes('-');
	}

	ngOnDestroy() {
		this.header.show();
	}

	keyPressNumbers(event) {
		var charCode = (event.which) ? event.which : event.keyCode;
		// Only Numbers 0-9
		if ((charCode < 48 || charCode > 57) && charCode != 45) {
		  event.preventDefault();
		  return false;
		} else {
		  return true;
		}
	  }
}
